import React, { useState, useEffect, useRef } from "react";
import { IconButton, TextField, CircularProgress, Typography } from "@mui/material";
import { Send, StopCircleRounded, MicOff } from "@mui/icons-material";
import { useVoiceVisualizer, VoiceVisualizer } from "react-voice-visualizer";
import { useWhisper } from "./hooks/useWhisper";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../globals/redux/store/store.index";
import * as ChatThunks from "./chat.thunks";
import { MicButton } from "../../assets/svgicons";
import "./chat.input.less";
import { CallEnd } from "@mui/icons-material";

interface ChatInputProps {
    videoPlaying: boolean;
    onTerminateSession: any;
}

const ChatInput: React.FC<ChatInputProps> = ({ videoPlaying, onTerminateSession }) => {
    const dispatch = useDispatch();
    const chatState = useSelector((state: RootState) => state.chatV2Reducer);

    const [input, setInput] = useState("");
    const [messageInputType, setMessageInputType] = useState<"text" | "voice">("text");
    const [isRecording, setIsRecording] = useState(false);

    const inputRef = useRef<HTMLInputElement | null>(null);
    const recorderControls = useVoiceVisualizer();

    const {
        secondsRef, transcript, transcribing, startRecording, stopRecording,
        resetTranscript, stopUpdatingSeconds
    } = useWhisper({ removeSilence: true, timeSlice: 2000, streaming: true });

    const { audioRef, startRecording: startVisualRecording, stopRecording: stopVisualRecording } = recorderControls;
    const [isDesktop, SetIsDesktop] = useState("desktop");
    const CheckWindowSize = () => {
        let windowWidth;
        if (typeof window !== "undefined") {
            windowWidth = window.innerWidth;
        }
        if (windowWidth >= 1024) {
            SetIsDesktop("desktop")
        }
        else {
            SetIsDesktop("mobile")
        }

    }
    useEffect(() => {
        CheckWindowSize()
        console.log("isDesktop", isDesktop)
    }, [isDesktop])

    useEffect(() => {
        console.log('transcript?.text', transcript?.text)
        setInput(transcript?.text || "");
    }, [transcript]);

    useEffect(() => {
        if (chatState.sendMessageApiStatus === "success") {
            setInput("");
            resetTranscript();
            stopVisualRecording();
            setMessageInputType("voice");
            setIsRecording(false);
        } else if (chatState.sendMessageApiStatus === "failed") {
            setIsRecording(false);
        }
    }, [chatState.sendMessageApiStatus]);

    const submitMessage = () => {
        if (input?.trim()?.length > 0) {
            dispatch(ChatThunks.postNewMessage(input.trim(), messageInputType, chatState.chatType, chatState.chatSessionId, true, isDesktop));
            setInput("");
            setIsRecording(false);
        }
    };

    const toggleChatInputType = () => {
        setInput("");
        if(isRecording){
            stopRecording();
            stopVisualRecording();
            resetTranscript();
            setMessageInputType("voice");
            setIsRecording(false);
        }else{
            setMessageInputType("voice");
            startRecording();
            startVisualRecording();
            setIsRecording(true);
        }
        
        // if (messageInputType === "text") {
        //     setMessageInputType("voice");
        //     startRecording();
        //     startVisualRecording();
        //     setIsRecording(true);
        // } else {
        //     stopRecording();
        //     stopVisualRecording();
        //     resetTranscript();
        //     setMessageInputType("voice");
        //     setIsRecording(false);
        // }
    };

    return (
        <div className="chat-input-container">
            {isRecording ? (
                <div className="recording-container">
                    <Typography variant="body2" color="textSecondary">
                        {secondsRef.current > 1 ? `Silence detected. Stopping in ${secondsRef.current}s` : "Recording..."}
                    </Typography>
                    <VoiceVisualizer
                        ref={audioRef}
                        controls={recorderControls}
                        height={70}
                        width="100%"
                        mainBarColor="#FBB117"
                        canvasContainerClassName="canvas-container"
                        isControlPanelShown={false}
                        barWidth={4}
                        secondaryBarColor="#EFEEEE"
                    />
                    <IconButton onClick={() => {
                        stopRecording();
                        stopVisualRecording();
                        setMessageInputType("voice");
                        setIsRecording(false);
                    }} title="Stop recording">
                        <StopCircleRounded />
                    </IconButton>
                </div>
            ) : (
                <TextField
                    fullWidth
                    multiline
                    // disabled={videoPlaying}
                    className="chat-input-field"
                    maxRows={2}
                    placeholder={
                        chatState.sendMessageApiStatus === "inprogress"
                            ? "Thinking..."
                            : videoPlaying
                                ? "Speaking..."
                                : "Type your message here..."
                    } value={input || ""}
                    inputRef={inputRef}
                    onKeyUp={(event) => {
                        if (event.key === "Enter" && input?.trim()?.length > 0) {
                            submitMessage();
                        }
                    }}
                    onChange={(event) => {
                        setInput(event.target.value);
                    }}
                    InputProps={{
                        endAdornment: (
                            chatState.sendMessageApiStatus === "inprogress" ? (
                                <CircularProgress size={24} />
                            ) : (
                                <IconButton
                                    title="Send"
                                    disabled={!input.trim() || videoPlaying}
                                    onClick={submitMessage}
                                    className={`send-button ${input?.length ? "active" : ""}`}
                                >
                                    <Send />
                                </IconButton>
                            )
                        ),
                    }}
                />
            )}
            
                    <IconButton
                        className="mic-toggle-button"
                        title={messageInputType === "text" ? "Turn Off Microphone" : "Turn On Microphone"}
                        disabled={videoPlaying}
                        onClick={toggleChatInputType}
                    >
                         {transcribing ? (
                    <CircularProgress size={27} sx={{ color: 'white' }} />
                ):(
                        <div className="mic-button">
                            {!isRecording ? (
                                <MicButton />
                            ) : (
                                <StopCircleRounded style={{ color: 'white' }} />
                            )}
                        </div>
                        )}
                    </IconButton>
                

            <IconButton
                className="video-cut"
                title={"Turn Off Video Mode"}
                onClick={onTerminateSession}
            >
                <CallEnd />
            </IconButton>
        </div>
    );
};

export default ChatInput;
